import { render, staticRenderFns } from "./materialSeparation.vue?vue&type=template&id=38dc0b7a&"
import script from "./materialSeparation.vue?vue&type=script&lang=js&"
export * from "./materialSeparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports